// Burn a date/time stamp into the bottom-left of a canvas context.
export function drawStamp(ctx, w, h) {
  const fs = Math.max(14, Math.round(w * 0.028));
  const pad = Math.round(fs * 0.5);
  const text = new Date().toLocaleString();
  ctx.font = `bold ${fs}px monospace`;
  ctx.textBaseline = "top";
  const tw = ctx.measureText(text).width;
  const boxH = fs + pad;
  const y = h - boxH - pad;
  ctx.fillStyle = "rgba(0,0,0,0.6)";
  ctx.fillRect(pad - 4, y - 2, tw + 14, boxH + 4);
  ctx.fillStyle = "#FF5722";
  ctx.fillText(text, pad + 3, y + 2);
}

// Return a new JPEG File with the timestamp burned in. Falls back to original on error.
export function stampImageFile(file) {
  return new Promise((resolve) => {
    const img = new Image();
    img.onload = () => {
      try {
        const canvas = document.createElement("canvas");
        canvas.width = img.naturalWidth;
        canvas.height = img.naturalHeight;
        const ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0);
        drawStamp(ctx, canvas.width, canvas.height);
        canvas.toBlob(
          (blob) => resolve(blob ? new File([blob], file.name.replace(/\.[^.]+$/, "") + "_stamped.jpg", { type: "image/jpeg" }) : file),
          "image/jpeg",
          0.92
        );
      } catch {
        resolve(file);
      } finally {
        URL.revokeObjectURL(img.src);
      }
    };
    img.onerror = () => { URL.revokeObjectURL(img.src); resolve(file); };
    img.src = URL.createObjectURL(file);
  });
}
